import routeName from '../../../routes/route-name';
import action from '../../abstract/action';

export default action({
  label: 'Edytuj',
  icon: 'EditIcon',
  main: () => true,
  handle: async ({ $router, item }) => await $router.push({ name: routeName.partnerStaffBoardMember.edit, params: { id: item.id } }),
});
